import { HttpContextToken } from '@angular/common/http';

// Keeps the health probe a "simple" CORS request: no auth headers means no
// preflight, so each probe costs one round trip instead of two.
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

// A failing probe must not itself be reported as evidence of an outage.
export const SKIP_OFFLINE_REPORT = new HttpContextToken<boolean>(() => false);
